import React from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Icon, Typography } from '@ui';
import { Flex } from 'antd';

export const Tip = ({ text, justify = 'flex-start' }) => {
    if (!text) return null;

    return (
        <Flex gap={16} justify={justify} style={BOTTOM_INDENTS.S}>
            <Icon color={`${COLORS.$gray40Black} !important`} size='24px' component={() => <Icon.InfoFilledIcon />} />
            <Typography.Text type='descriptor1' color={COLORS.$gray60Black}>
                {text}
            </Typography.Text>
        </Flex>
    );
};
